// Арт-режим оболочки: аниме или реал.
//
// Курс проекта (решение Дениса, 2026-07-27): АНИМЕ — в браузере, сейчас;
// РЕАЛ — позже, отдельной сборкой под Steam. Дизайн-система это уже
// поддерживает: оба режима живут на одном коде, отличаются только значениями
// токенов (акцент, стекло, тени, свечение). Геометрия и отступы общие.
//
// Переключатель — атрибут data-art на корне документа. Никакой второй темы,
// второго файла стилей и ветвлений в компонентах: компонент не знает, в каком
// режиме он живёт, и не должен знать.

const STORAGE_KEY = 'testcs.art.v1'

export const ART_MODES = [
  { id: 'anime', label: 'АНИМЕ', hint: 'Неон и свечение. Текущий курс браузерной версии.' },
  { id: 'real', label: 'РЕАЛ', hint: 'Сдержанная подача. Готовится к сборке под Steam.' },
]

// Браузерная версия — аниме. Реал включается вручную и живёт как заготовка
// под будущий нативный клиент.
export const DEFAULT_ART_MODE = 'anime'

export function isArtMode(value) {
  return ART_MODES.some(mode => mode.id === value)
}

export function loadArtMode() {
  try {
    const stored = localStorage.getItem(STORAGE_KEY)
    return isArtMode(stored) ? stored : DEFAULT_ART_MODE
  } catch {
    return DEFAULT_ART_MODE
  }
}

export function saveArtMode(mode) {
  if (!isArtMode(mode)) return false
  try {
    localStorage.setItem(STORAGE_KEY, mode)
    return true
  } catch {
    return false
  }
}

// Повесить режим на корень документа. Дизайн-система читает его сама.
export function applyArtMode(mode) {
  const next = isArtMode(mode) ? mode : DEFAULT_ART_MODE
  if (typeof document !== 'undefined') {
    document.documentElement.setAttribute('data-art', next)
  }
  return next
}

// Вызывается один раз при старте клиента.
export function initArtMode() {
  return applyArtMode(loadArtMode())
}

export function setArtMode(mode) {
  const next = applyArtMode(mode)
  saveArtMode(next)
  return next
}
